import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import Router from "./routes/Router";
import reportWebVitals from "./reportWebVitals";
import { login } from "./utils/authentication";
import store from "./store";

import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { CurrentUserContextProvider } from "./hooks/auth/useCurrenttUser";

import { init as initApm } from "@elastic/apm-rum"

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const apm = initApm({
  serviceName: `${process.env.REACT_APP_APM_SERVICE_NAME}`,
  serverUrl: `${process.env.REACT_APP_APM_SERVER_URL}`,
  environment: `${process.env.REACT_APP_APM_ENVIRONMENT}`,
  distributedTracingOrigins: [`${process.env.REACT_APP_API_BASE_URL}`],
  propagateTracestate: true
})
apm.addLabels({adoid: `${process.env.REACT_APP_APM_ADO_ID}`, pn: `${process.env.REACT_APP_APM_PRODUCT_NAME}`, bs: `${process.env.REACT_APP_APM_BUSINESS_STREAM}`})
var loginState = sessionStorage.getItem('loginState');

if(loginState === undefined || loginState === null){
  login();
}
else{
  root.render(
    // <React.StrictMode>
      <Provider store={store}>
        <CurrentUserContextProvider>
          <RouterProvider router={Router} />
        </CurrentUserContextProvider>
      </Provider>
    //</React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
